export default (args) => {
    let result = '';
    args.forEach((arg) => {
        result += arg;
    });
    return result;
};
